import React, {useState} from 'react';
import {Button, Input, message, Space} from 'antd';
import {Auth} from "@aws-amplify/auth";

const constantTimeEquals = (a, b) => {
    if (a.length !== b.length) return false;
    let result = 0;
    for (let i = 0; i < a.length; i++) {
        result |= a.charCodeAt(i) ^ b.charCodeAt(i);
    }
    return result === 0;
};

const ResetPassword = (props) => {
    const [currentPassword, setCurrentPassword] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');

    const handleOk = () => {
        if (currentPassword === '') {
            message.warning("Please enter current password!");
        } else{
            const isPasswordEmpty = !password;
            const isConfirmPasswordEmpty = confirmPassword.length === 0;
            if (isPasswordEmpty || isConfirmPasswordEmpty ) {
                message.warning("Please enter new password and confirm it!");
            } else if (!constantTimeEquals(password, confirmPassword)) {
                message.warning("Passwords don't match!");
            } else {
                Auth.currentAuthenticatedUser()
                    .then(user => {
                        return Auth.changePassword(user, currentPassword, password);
                    })
                    .then(data => {
                        message.success("Password changed successfully.");
                        setCurrentPassword('');
                        setPassword('');
                        setConfirmPassword('');
                    })
                 .catch(err => message.error(err.message));
            }
        }
    };

    return (
        <>

            <div style={{marginTop: 20}}>
                <Space direction="vertical" style={{width: '40%'}}>
                    <Input.Password placeholder="Current Password" value={currentPassword}
                                    onChange={(e) => setCurrentPassword(e.target.value)}/>
                    <Input.Password placeholder="New Password" value={password}
                                    onChange={(e) => setPassword(e.target.value)}/>
                    <Input.Password placeholder="Confirm New Password" value={confirmPassword}
                                    onChange={(e) => setConfirmPassword(e.target.value)}/>
                    <Button type="primary" onClick={handleOk}>Save</Button>
                </Space>


            </div>

        </>
    );
};

export default ResetPassword;